<template>
    <div class="display-media">
        <template v-if="previewType === 'image'">
            <t-img :src="currentMedia.full_url" :style="style" :fluid="true" alt="Media" @load="onLoad"></t-img>
        </template>

        <template v-if="previewType === 'audio'">
            <div class="center-media-container" :style="style">
                <audio @load="$emit('load')" controls>
                    <source :src="currentMedia.full_url" />
                    Your browser does not support the audio tag.
                </audio>
            </div>
        </template>

        <template v-if="previewType === 'video'">
            <div class="video-container">
                <video controls style="max-width: 100%; max-height: 400px; width: auto; height: auto">
                    <source :src="currentMedia.full_url" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </template>

        <template v-if="previewType === 'text'">
            <textarea :value="currentMedia.text" readonly="readonly" :style="style"></textarea>
        </template>

        <template v-if="previewType === 'office'">
            <div class="embed-responsive embed-responsive-1by1">
                <iframe :src="'https://docs.google.com/viewer?url=' + currentMedia.full_url + '&embedded=true'" class="embed-responsive-item"></iframe>
            </div>
        </template>

        <template v-if="previewType === 'pdf'">
            <div class="embed-responsive embed-responsive-1by1">
                <embed :src="currentMedia.full_url" type="application/pdf" :style="style" class="embed-responsive-item" />
            </div>
        </template>
    </div>
</template>

<script>
import { guessFileType } from '@jgile/laravel-vue/resources/js/lib/helpers';

export default {
    props: {
        media: {
            required: true,
        },
        height: {
            default: null,
        },
        width: {
            default: null,
        },
        config: {
            default() {
                return {};
            },
        },
    },
    data: () => ({
        defaultStyle: 'max-width: 100%;',
        currentMedia: null,
        configuration: null,
    }),
    computed: {
        style() {
            let style = '';

            if (this.height) {
                return (style += `height: ${this.height}`);
            }

            if (this.width) {
                return (style += `width: ${this.width}`);
            }

            return style ? style : this.defaultStyle;
        },
        previewType() {
            if (!this.currentMedia) {
                return '';
            }

            return _.get(this.currentMedia, 'preview_type', guessFileType(this.currentMedia.name ? this.currentMedia.name : this.currentMedia.full_url));
        },
    },
    methods: {
        onLoad(payload) {
            this.$emit('load', payload);
        },
    },
    created() {
        this.configuration = _.merge(this.defaultConfig, this.config);
    },
    watch: {
        media: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.currentMedia = _.isArray(newVal) ? newVal[0] : newVal;
            },
        },
    },
};
</script>

<style>
.center-media-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.video-container video {
    display: block;
}
</style>
